import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Stack,
  Divider,
} from "@mui/material";
import { Person, AccessTime } from "@mui/icons-material";
import { concatSelectedFromToTime } from "../../services/date-and-time.utils";

function SlotDetailsCard({ from, to, title }) {
  return (
    <Card elevation={1} sx={styles.card}>
      <CardContent sx={styles.cardContent}>
        {/* Header */}
        <Box sx={styles.header}>
          <Person sx={styles.personIcon} />
          <Typography variant="subtitle2" sx={styles.title}>
            {title}
          </Typography>
        </Box>

        <Divider sx={styles.divider} />

        {/* Time Details */}
        <Stack spacing={1.5}>
          <Box>
            <Box sx={styles.timeContainer}>
              <AccessTime sx={styles.timeIcon} />
              <Typography variant="caption" sx={styles.timeLabel}>
                Meeting Time
              </Typography>
            </Box>
            <Typography variant="body2" sx={styles.timeValue}>
              {concatSelectedFromToTime({ from, to })}
            </Typography>
          </Box>
        </Stack>

        {/* Duration */}
        <Box sx={styles.durationContainer}>
          <Chip
            label="45 min"
            size="small"
            variant="outlined"
            sx={styles.durationChip}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

const styles = {
  card: {
    borderRadius: 2,
    border: "1px solid #e0e0e0",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  },
  cardContent: {
    p: 2,
  },
  header: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  personIcon: {
    mr: 1,
    color: "primary.main",
    fontSize: 18,
  },
  title: {
    fontWeight: 600,
    fontSize: 12,
    color: "text.primary",
  },
  divider: {
    mb: 2,
  },
  timeContainer: {
    display: "flex",
    alignItems: "center",
    mb: 0.5,
  },
  timeIcon: {
    mr: 1,
    color: "text.secondary",
    fontSize: 14,
  },
  timeLabel: {
    color: "text.secondary",
    fontWeight: 500,
    fontSize: 11,
  },
  timeValue: {
    fontWeight: 500,
    color: "text.primary",
    fontSize: 13,
    ml: 2.5,
  },
  durationContainer: {
    mt: 2,
    display: "flex",
    justifyContent: "center",
  },
  durationChip: {
    borderColor: "primary.main",
    color: "primary.main",
    fontWeight: 500,
    fontSize: 11,
    height: 22,
  },
};

export { SlotDetailsCard };
